import React, { useState, useContext, useRef, useEffect } from 'react';
import authenticationCtx from 'context/authentication';

const LoginForm = props => {
	const [account, setAccount] = useState('');
	const [password, setPassword] = useState('');
	const [passkeySupported, setPasskeySupported] = useState(false);
	const [passkeyBusy, setPasskeyBusy] = useState(false);
	const { tryLogin, tryLoginPasskey, initialized } = useContext(authenticationCtx);
	const passwordRef = useRef();

	const formValid = !!account && !!password;

	useEffect(() => {
		if (typeof window !== 'undefined' && window.PublicKeyCredential) {
			setPasskeySupported(true);
		}
	}, []);

	const handleChangeEmail = e => {
		setAccount(e.target.value);
	};

	const handleChangePassword = e => {
		setPassword(e.target.value);
	};

	const handleKeyDownEmail = e => {
		if (e.keyCode === 13) {
			passwordRef.current.focus();
		}
	};

	const submitForm = async e => {
		e.preventDefault();
		if (formValid) {
			const success = await tryLogin(account, password);
			if (!success) {
				setPassword('');
			}
		}
	};

	const handlePasskeyLogin = async () => {
		setPasskeyBusy(true);
		try {
			await tryLoginPasskey();
		} finally {
			setPasskeyBusy(false);
		}
	};

	let passkeyLogin;
	if (passkeySupported) {
		passkeyLogin = (
			<>
				<div className="flex items-center gap-3 text-sm text-white/40">
					<span className="h-px flex-1 bg-white/20" />
					or
					<span className="h-px flex-1 bg-white/20" />
				</div>
				<button
					type="button"
					onClick={handlePasskeyLogin}
					disabled={passkeyBusy}
					className="rounded whitespace-nowrap text-center flex gap-x-3 items-center text-lg border border-indigo-300 text-white hover:bg-indigo-800 active:bg-indigo-900 justify-center px-3 py-2 disabled:opacity-50 disabled:cursor-not-allowed"
				>
					Sign in with a passkey
				</button>
			</>
		);
	}

	return (
		<form className="container flex flex-col max-w-sm gap-4 max-md:mt-20" onSubmit={submitForm}>
			<input
				type="text"
				onChange={handleChangeEmail}
				onKeyDown={handleKeyDownEmail}
				value={account}
				placeholder="email"
				className="form-input w-full rounded border border-indigo-300 bg-transparent px-4 py-3 text-white placeholder:text-white/25"
				autoFocus
			/>
			<input
				type="password"
				ref={passwordRef}
				onChange={handleChangePassword}
				value={password}
				placeholder="password"
				autoComplete="current-password"
				className="form-input w-full rounded border border-indigo-300 bg-transparent px-4 py-3 text-white placeholder:text-white/25"
			/>
			<button
				disabled={!formValid}
				className="rounded whitespace-nowrap text-center flex gap-x-3 items-center text-lg bg-yellow-400 text-black hover:bg-yellow-500 active:bg-yellow-400 justify-center px-3 py-2"
			>
				Login
			</button>
			{passkeyLogin}
		</form>
	);
};

export default LoginForm;
